<script lang="ts">
	import Button from '$lib/Button.svelte';
	import StrapiImage from '$lib/StrapiImage.svelte';

	interface Props {
		stickyCta: Populated<StickyCta, 'coverMobile' | 'coverDesktop'>;
		device: 'desktop' | 'mobile';
	}

	let { stickyCta, device }: Props = $props();
</script>

{#if device === 'desktop'}
	<div>
		<div class="mb-3 w-full">
			<div class="mb-3 flex items-center gap-5">
				<StrapiImage cover={stickyCta.coverDesktop} class="mb-1 block w-24 grow-0" />
				<p class="card-bold">{stickyCta.coverDesktop.alternativeText}</p>
			</div>
			<p class="card-regular">
				{@html stickyCta.description}
			</p>
		</div>
		<Button
			to={{
				href: stickyCta.url,
				'data-type': 'sticky-cta',
				target: '_blank',
				rel: 'noreferrer noopener nofollow'
			}}
			class="w-full"
		>
			{stickyCta.text}
		</Button>
	</div>
{:else}
	<div
		class="border-t-gray-light bg-white-pure fixed bottom-0 z-40 w-screen max-w-none border-t-1 px-2 py-3 shadow-[0_-4px_8px_0_rgba(0,0,0,0.08)] md:hidden"
	>
		<div class="mb-3 flex w-full items-center gap-5">
			<div class="shrink-0">
				<StrapiImage cover={stickyCta.coverMobile} class="mx-auto mb-1 block w-24" />
				<p class="small-bold">{stickyCta.coverMobile.alternativeText}</p>
			</div>
			<p class="card-regular">
				{@html stickyCta.description}
			</p>
		</div>
		<Button
			to={{
				href: stickyCta.url,
				'data-type': 'sticky-cta',
				target: '_blank',
				rel: 'noreferrer noopener nofollow'
			}}
			class="w-full"
		>
			{stickyCta.text}
		</Button>
	</div>
{/if}
